import React from 'react';
import useTranslation from '../hooks/useTranslation';

export default function DeleteAccountModal({ open, onClose, onDeleteAccount }) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div className="login-modal-bg" style={{ zIndex: 9999 }}>
      <div className="login-card" style={{ minWidth: 320, maxWidth: 420, width: '90vw', padding: '2.2rem 2rem 2.2rem 2rem', position: 'relative', background: 'var(--color-modal-bg)', color: 'var(--color-modal-text)' }}>
        <button
          type="button"
          className="login-close-btn"
          aria-label="Close Delete Account Modal"
          onClick={onClose}
          style={{ right: '1.5rem', left: 'auto', top: '1.7rem', position: 'absolute' }}
        >
          <span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 300, fontSize: '1.5em', lineHeight: 1 }}>×</span>
        </button>
        <h1 style={{ marginBottom: '0.7rem', fontSize: '2.1rem', fontWeight: 700, color: '#e53935', letterSpacing: '0.5px', textAlign: 'center' }}>{t('Deactivate Account')}</h1>
        <div style={{ margin: '1.2rem 0 0.7rem 0', width: '100%', textAlign: 'center' }}>
          <div style={{ fontWeight: 600, fontSize: '1.08rem', marginBottom: '0.7rem', color: '#232323' }}>{t('Are you sure you want to delete your account? This action cannot be undone.')}</div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '1.2rem', marginTop: '2.2rem' }}>
            <button
              className="login-btn submit"
              style={{ background: '#e53935', color: '#fff', fontWeight: 700, minWidth: 120 }}
              onClick={onDeleteAccount}
            >
              {t('Yes, Delete')}
            </button>
            <button
              className="login-btn submit"
              style={{ background: '#fff', color: '#e53935', border: '2px solid #e53935', fontWeight: 700, minWidth: 120 }}
              onClick={onClose}
            >
              {t('Cancel')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
